// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/square-kanban.js';

import { paths } from '../generated/square-kanban';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('square-kanban', Original, paths);
